import React from "react";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import LoadingButton from "../CustomComponents/LoadingButton";

const DeleteModal = ({
  handleDeleteModalClose,
  cnfrmtext,
  text,
  data,
  onDelete,
  cancel,
  cnfrm,
  screen,
  userText = true,
  isLoading,
}) => {
  return (
    <div>
      <ModalContainer handleClose={handleDeleteModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between">
            <p className="fs-4 fw-medium m-0">{cnfrmtext}</p>
            <span className="bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                size={25}
                role="button"
                onClick={handleDeleteModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="flex-center flex-column">
            <div className="">
              <p>
                Do you want to {text}{" "}
                <b>
                  {data
                    ? data?.first_name && data?.last_name
                      ? data?.first_name + " " + data?.last_name
                      : data?.displayName
                      ? data?.displayName
                      : userText
                      ? "User"
                      : ""
                    : ""}
                </b>
                ?{" "}
              </p>
            </div>

            <div className="d-flex justify-content-center align-items-center">
              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-dark"
                role="button"
                onClick={handleDeleteModalClose}
              >
                <span className={`mx-2 d-flex text-white`}>{cancel}</span>
              </div>

              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-danger"
                role="button"
                onClick={() => {
                  onDelete(data?.id);
                }}
              >
                <span className={`mx-2 d-flex text-white`}>
                  {isLoading ? <LoadingButton /> : cnfrm}
                </span>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DeleteModal;
